import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import $ from 'jquery';
import Header from "./include/Header";

import Apihelpers from './helper/ApiHelper';

class FuelTransmission extends Component {
  state = {
    MsgBoxText: '',
    filterType:{
      startpage:0,
      limit:20,
      type:'fuel',
      search:''
    },
    records:[],
    totalCount:0,
    updateFormData:{
      name:'',
      keytype:'',
      id:''
    }
  };
  //alias --  transmission  --- fuel
  constructor(props) {
    super(props);

  }
  componentDidMount() {
    // setTimeout( () => {
    //   $("#mapping_fileter").select2('focus');
    // }, 500);
    $(document).ready(function () {
        $(".okBtn").click(function () {
          $("#infoPopUp1").hide();
          //$("#infoPopUp1 .textA").css("color","");
        });

        $(".updateFuleTranForm .backBtn ").click(()=>{
          $("#recordEditPopUp").hide();
        })
    });

    this.getRecordList();
  }
  getRecordList = () => {
    let url = 'fueltype/alltypedata';
    //let start = this.state.filterType.limit * this.state.filterType.startpage;
    let data = {
      startpage:this.state.filterType.startpage,
      limit:this.state.filterType.limit,
      type:this.state.filterType.type,
      search:this.state.filterType.search
    }
    Apihelpers.postdataresponse(url,data)
    .then((res)=>{
        //console.log('res',res);
        if (res.data.status == true) {
            this.setState({
              records: res.data.data,
              totalCount: res.data.totalCount
            });
        } else {
            $("#infoPopUp1").show();
            $("#infoPopUp1 .textA").css("color","red");
            this.setState({
                MsgBoxText: res.data.message
            });
        }
    })
  }
  loadPage = (e) => {
    //console.log('e',e.target.getAttribute("data-i"));
    let start = Number(e.target.getAttribute("data-i"));
    this.setState({
      filterType: {...this.state.filterType, startpage: start}
    });
    setTimeout(()=>{
      this.getRecordList();
    },100);
  }
  changeLimit = (e) => {
    let limit = Number(e.target.value);
    this.setState({
      //filterType: {...this.state.filterType, limit: limit}
      filterType: {
        startpage:0,
        limit:limit,
        search:this.state.filterType.search,
        type: this.state.filterType.type
      }
    });
    setTimeout(()=>{
      this.getRecordList();
    },100);
  }
  changeType = (e) => {
    this.setState({
      //limit:5,
      //filterType: {...this.state.filterType, type: e.target.value}
      filterType: {
        startpage:0,
        limit:this.state.filterType.limit,
        search:this.state.filterType.search,
        type: e.target.value
      }
    });
    setTimeout(()=>{
      this.getRecordList();
    },100);
  }

  deleteRecord = (e) => {
    let id = e.target.getAttribute("data-id");
    if (window.confirm("Are you sure you want to delete this record.") == true) {
      console.log('id',id);
      let url = 'fueltype/removetype';
      Apihelpers.postdataresponse(url,{"_id":id,"type":this.state.filterType.type})
      .then((res)=>{
          console.log('res',res);
          if (res.data.status == true) {
            $("#infoPopUp1").show();
            $("#infoPopUp1 .textA").css("color","green");
            this.setState({
                MsgBoxText: res.data.message
            });
            this.getRecordList();
          } else {
            $("#infoPopUp1").show();
            $("#infoPopUp1 .textA").css("color","red");
            this.setState({
                MsgBoxText: res.data.message
            });
          }
      })
    }
  }
  editRecord = (e) => {
    let id = e.target.getAttribute("data-id");
    console.log('id',id);
    let obj = this.state.records.filter((item)=>{
      if (item._id === id) {
        return item;
      }
    });

    let keytype = this.state.filterType.type+'_type';
    if(this.state.filterType.type == 'alias') {
      keytype = 'alias_name'; 
    }
    //console.log('obj',obj);
    this.setState({
      updateFormData:{
        name:obj[0].name,
        keytype:obj[0][keytype],
        id:obj[0]._id
      }
    });
    $("#recordEditPopUp").show();
  }

  inputHandle = (e) => {
    let val = e.target.value;
    let key = e.target.name;
    console.log('val: ',val,', key: ',key);
    this.setState({
      updateFormData : {...this.state.updateFormData, [key]:val}
    })
  }
  updateForm = (e) => {
    e.preventDefault();
    let url = 'fueltype/updatetype';
    let obj = {
      key:this.state.updateFormData.name,
      keytype:this.state.updateFormData.keytype,
      _id:this.state.updateFormData.id,
      type:this.state.filterType.type
    };
    //console.log('obj',obj);
    Apihelpers.postdataresponse(url,obj)
    .then((res)=>{
        console.log('res',res);
        $("#recordEditPopUp").hide();
        if (res.data.status == true) {
            this.getRecordList();
            this.setState({
                MsgBoxText: res.data.message,
                updateFormData : {
                    name:'',
                    keytype:''
                }
            });
            $("#infoPopUp1").show();
            $("#infoPopUp1 .textA").css("color","green");
        } else {
            $("#infoPopUp1").show();
            $("#infoPopUp1 .textA").css("color","red");
            this.setState({
                MsgBoxText: res.data.message
            });
        }
    })
  }
  searchBy = (e) => {
    e.preventDefault();
    this.setState({
      filterType: {...this.state.filterType, startpage:0}
    });
    setTimeout(()=>{
      this.getRecordList();
    },100);
  }
 
  render() {
    const renderPaging = () => {
      let pages = (this.state.totalCount / this.state.filterType.limit);
      //console.log('pages',pages);
      let pagingHmtl = [];
      for (var i = 0; pages > i; i++ ) {
        pagingHmtl.push(<span key={i} data-i={i} className={(this.state.filterType.startpage == i) ? 'btn active' : 'btn'} onClick={(e)=>{this.loadPage(e)}}>{i+1}</span>);
      }
      return pagingHmtl;
    }
    return (
      <div className="wrapper">
        <Header />
        <div className="container">
          <div className="fuelTypePage">
            <div className="titleRow">
              <div className="row">
                <div className="col">
                  <h3 className="title">Fuel, Transmission, Aliases and Commercial Vehicles</h3>
                  <span className="desc">Showing <strong>{this.state.records.length}</strong> out of <strong>{this.state.totalCount}</strong></span>

                  {
                    //JSON.stringify(this.state.filterType)
                  }
                </div>
                <div className="col-auto">
                  <form className="searcBy" onSubmit={this.searchBy}>
                    <input className="form-control" type="text" placeholder="Search by key & value" name="" onChange={(e) => {
                      this.setState({
                        filterType: {...this.state.filterType, search: e.target.value}
                      })
                    }} />
                    <button className="subBtn"></button>
                  </form>
                </div>
                <div className="col-auto">
                  <select className="form-control" onChange={this.changeType}>
                    <option value="fuel">Fuel</option>
                    <option value="transmission">Transmission</option>
                    <option value="alias">Aliases</option>
                    <option value="commercial">Commercial Vehicle</option>
                  </select>
                </div>
                <div className="col-auto">
                    <NavLink to={"/admin/fuel-transmission-create"} className="backLink"> Create <i className="fa fa-arrow-right"></i> &nbsp; </NavLink>
                </div>
              </div>
            </div>
            <div className="tableBorder">
              <table className="table">
                <tbody>
                  <tr>
                    <th>Type</th>
                    <th>Key</th>
                    <th>Value</th>
                    <th>Action</th>
                  </tr>
                  {
                    (this.state.records.length > 0) ?
                    this.state.records.map((item, i)=>(
                      <tr key={i}>
                        <td>
                          {
                            (this.state.filterType.type == 'fuel') ? 'Fuel' : (this.state.filterType.type == 'transmission') ? 'Transmission' : (this.state.filterType.type == 'commercial') ? 'Commercial' : (this.state.filterType.type == 'alias') ? 'Aliases' : '-'
                          }
                        </td>
                        <td>
                          {
                            (this.state.filterType.type == 'alias') ?
                            item.alias_name
                            :
                            item[this.state.filterType.type+'_type']
                          }
                        </td>
                        <td>{item.name}</td>
                        <td>
                          <div className="icons">
                            <button className="sprite edit" data-id={item._id} data-type={this.state.filterType.type} type="button" title="Edit" onClick={this.editRecord}>&nbsp;</button>
                            <button className="sprite delete" data-id={item._id} data-type={this.state.filterType.type} type="button" title="Delete" onClick={this.deleteRecord}>&nbsp;</button>
                          </div>
                        </td>
                      </tr>
                    ))
                    :
                    <tr><td colSpan={4}>no record found...</td></tr>
                  }
                </tbody>
              </table>
            </div>
            <div className="row">
              <div className="col">
                <div className="pageing">
                  {/* <span className="btn active">1</span>
                  <span className="btn">2</span>
                  <span className="btn">3</span>
                  <span className="btn">4</span> */}
                  {renderPaging()}
                </div>
              </div>
              <div className="col-auto">
                <select className="form-control" onChange={this.changeLimit}>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option selected value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="customPopup" id="infoPopUp1">
          <div className="bgLayer"></div>
          <div className="popUpBox">
            <div className="popScroll">
              <div className="infoMessagePopUp">
                <div className="textA" style={{color:"green"}}>{this.state.MsgBoxText}</div>
                <div className="submitRow">
                  <button className="blueBtn okBtn" tabIndex="5" type="button">OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="customPopup" id="recordEditPopUp">
          <div className="bgLayer"></div>
          <div className="popUpBox" style={{maxWidth:'600px'}}>
            <div className="popScroll">
              {
                //JSON.stringify(this.state.updateFormData)
              }
              <form id="updateForm" className="form updateFuleTranForm" onSubmit={this.updateForm}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="control-title">Type</label>
                      <input type="text" className="form-control" disabled value={(this.state.filterType.type == 'fuel') ? 'Fuel' : (this.state.filterType.type == 'transmission') ? 'Transmission' : (this.state.filterType.type == 'commercial') ? 'Commercial' : (this.state.filterType.type == 'alias') ? 'Aliases' : '-'} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                      {
                        (this.state.filterType.type === 'fuel') ?
                        <div className="form-group">
                            <label className="control-title typeLabel">Key</label>
                            <select className="form-control" required name="keytype" onChange={this.inputHandle} defaultValue={''}>
                                <option value="">--select--</option>
                                <option value="Diesel" selected={(this.state.updateFormData.keytype === 'Diesel')}>Diesel</option>
                                <option value="Petrol" selected={(this.state.updateFormData.keytype === 'Petrol')}>Petrol</option>
                                <option value="CNG" selected={(this.state.updateFormData.keytype === 'CNG')}>CNG</option>
                            </select>
                        </div>
                        : (this.state.filterType.type === 'commercial') ?
                        <div className="form-group">
                            <label className="control-title typeLabel">Key</label>
                            <select className="form-control" required name="keytype" onChange={this.inputHandle} defaultValue={''}>
                                <option value="">--select--</option>
                                <option value="Yes" selected={(this.state.updateFormData.keytype === 'Yes')}>Yes</option>
                                <option value="No" selected={(this.state.updateFormData.keytype === 'No')}>No</option>
                            </select>
                        </div>
                        :(this.state.filterType.type === 'alias') ?
                        <div className="form-group">
                            <label className="control-title typeLabel">Key</label>
                            <input className="form-control" required name="keytype" onChange={this.inputHandle} placeholder="enter actual model" defaultValue={this.state.updateFormData.keytype} />
                        </div>
                        :
                        <div className="form-group">
                            <label className="control-title typeLabel">Key</label>
                            <select className="form-control" required name="keytype" onChange={this.inputHandle} defaultValue={''}>
                                <option value="">--select--</option>
                                <option value="Automatic" selected={(this.state.updateFormData.keytype === 'Automatic')}>Automatic</option>
                                <option value="Manual" selected={(this.state.updateFormData.keytype === 'Manual')}>Manual</option>
                            </select>
                        </div>
                      }
                  </div>
                  <div className="col-md-6">
                      <div className="form-group">
                          <label className="control-title">Value</label>
                          <input type="text" className="form-control" name="name" placeholder="enter model" required onChange={this.inputHandle} defaultValue={this.state.updateFormData.name} />
                      </div>
                  </div>
                </div>
                <div className="btnRow">
                    <button className="backBtn" type="button">Cancel</button>
                    <button className="yellowBtn" type="submit">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default FuelTransmission;
